// extracted by mini-css-extract-plugin
module.exports = {"quote":"quote___2QwL9","author":"author___Xe7Qd","photo":"photo___sguwp","nick":"nick___3xFVt","position":"position___2QpUi","job":"job___jGaKk","text":"text___3aj9f"};